import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { PencilIcon, LinkIcon } from "@/components/developer/DashboardIcons";

interface ProjectCardProps {
  project: {
    id: string;
    title: string;
    year: number;
    description?: string;
    url?: string;
    technologies?: string[];
  };
  onEdit: (project: any) => void;
}

const ProjectCard = ({ project, onEdit }: ProjectCardProps) => {
  return (
    <div className="group relative">
      <div className="flex justify-between mb-2">
        <div>
          <h3 className="font-semibold">{project.title}</h3>
          {project.url && (
            <a
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-sm text-blue-600 hover:text-blue-800 mb-2"
            >
              <LinkIcon className="h-4 w-4 mr-1" />
              View project
            </a>
          )}
        </div>
        <div className="flex items-start gap-2">
          <p className="text-sm text-gray-600">{project.year}</p>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(project)}
          >
            <PencilIcon className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        {project.technologies?.map((tech: string) => (
          <Badge key={tech} variant="outline">
            {tech}
          </Badge>
        ))}
      </div>
      <p className="text-sm text-gray-600">{project.description}</p>
    </div>
  );
};

export default ProjectCard;